import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
export const useRedirectWithOriginalUrl = t0 => {
  const $ = _c(3);
  const {
    landingPageUrl
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== landingPageUrl || $[1] !== router) {
    t1 = {
      handleRedirect: () => {
        const hasOriginalRequestUrlForApp = window.history.length > 1 && document.referrer.indexOf(window.location.host) !== -1;
        if (hasOriginalRequestUrlForApp) {
          router.push(document.referrer);
        } else {
          router.push(landingPageUrl);
        }
      }
    };
    $[0] = landingPageUrl;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};